<template>
  <div class="loading-screen-wrapper">
    <div v-if="showComeBackLater" class="come-back-later">
      <img src="@/assets/images/icons/ic_inbox.svg" alt="Inbox Icon" class="inbox-icon" />
      <div class="come-back-later-text text-center">
        <p class="font-weight-bold">Check your inbox</p>
        <p>
          You'll receive an email & SMS soon with a link to <br> update your car details.
        </p>
      </div>
    </div>

    <div v-else class="moving-car">
      <div class="longfazers">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div class="centerpiece">
        <div class="body">
          <div class="fazers">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>

          <div class="car-wrapper">
            <img src="@/assets/images/car-side-solid.svg" alt="Car Icon" class="car-icon" />
          </div>
        </div>

        <h1 class="redirect-text text-center">{{ currentMessage }}</h1>
      </div>
    </div>
  </div>
</template>

<script>

import customerDetailService from "@/services/customer-detail";
import { API_ENDPOINT } from "@/config";

export default {
  name: 'LoadingScreen',
  data() {
    return {
      messages: [
        "Hold tight, we're shifting gears…",
        "Fueling up on data...",
        "Calibrating GPS...",
        "Warming up the engine...",
        "Locking in the best route..."
      ],
      currentMessageIndex: 0,
      intervalId: null,
      appraisalCheckInterval: null,
      appraisalTimeout: null,
      isAppraisalReady: false,
      showComeBackLater: false,
      apiEndPoint: API_ENDPOINT,
    };
  },
  computed: {
    currentMessage() {
      return this.messages[this.currentMessageIndex];
    },
    customerEmail() {
      return localStorage.getItem('customerEmail') || '';
    },
  },
  mounted() {
    this.startTextRotation();
    this.startAppraisalCheck();
  },
  methods: {
    startTextRotation() {
      this.intervalId = setInterval(() => {
        this.currentMessageIndex = (this.currentMessageIndex + 1) % this.messages.length;
      }, 5000);
    },
    stopTextRotation() {
      clearInterval(this.intervalId);
    },
    getMyCarPage() {
      let redirectBase = '';
      if (this.apiEndPoint.includes('psp-test')) {
        redirectBase = 'https://psp-test.idomitech.net/inv10';
      } else if (this.apiEndPoint.includes('psp-staging')) {
        redirectBase = 'https://psp-staging.idomitech.net/inv10';
      } else if (this.apiEndPoint.includes('autoflip.com.au')) {
        redirectBase = 'https://mycar.autoflip.com.au';
      }

      return redirectBase;
    },
    redirectToMyCarPage(appraisalId, hubspotLeadId) {
      const generatedTime = new Date();
      const platformId = appraisalId || hubspotLeadId;
      const redirectUrl = `${this.getMyCarPage()}?universal_login=true&appraisalId=${platformId}${
        this.locid === 2 ? "&locid=2" : ""
      }&generated_time=${generatedTime.getTime()}&utm_source=direct_mycar&email=${this.customerEmail}`;

      window.location.href = redirectUrl;
    },
    startAppraisalCheck() {
      // Simulate checking if appraisal is ready every 5 seconds
      this.appraisalCheckInterval = setInterval(this.checkAppraisalStatus, 5000);

      // If appraisal isn't ready after 70 seconds, show "Come back later"
      this.appraisalTimeout = setTimeout(async () => {
        if (this.isAppraisalReady) {
          try {
            const response = await customerDetailService.getAppraisalId(
              this.$store.getters.carDetailRecordId,
              { disableToast: true }
            );
            const appraisalId = response?.data?.appraisalId;
            const hubspotLeadId = response?.data?.hubspotLeadId;
            if (
              ["autoplay_upload_success", "hubspot_upload_success"].includes(
                response.data.uploadStatus
              ) &&
              (appraisalId || hubspotLeadId)
            ) {
              await customerDetailService.updatePSPDataLogsWithAction({
                appraisalId,
                hubspotLeadId,
                loggedAction: "MyCar Direct CTA",
              });
              localStorage.removeItem("customerEmail");
              this.redirectToMyCarPage(appraisalId, hubspotLeadId);
            }
          } catch (error) {
            console.error("Error during final redirect check:", error);
          }
        } else {
          await customerDetailService.updatePSPDataLogsWithAction({
            customerEmail: this.customerEmail,
            loggedAction: 'MyCar Direct CTA',
          });
          this.showComeBackLater = true;
          this.stopTextRotation(); // Stop the animation
          clearInterval(this.appraisalCheckInterval);
          localStorage.removeItem('customerEmail');
        }
      }, 70000);
    },
    async checkAppraisalStatus() {
      try {
        const response = await customerDetailService.getAppraisalId(
          this.$store.getters.carDetailRecordId,
          { disableToast: true }
        );
        const appraisalId = response?.data?.appraisalId;
        const hubspotLeadId = response?.data?.hubspotLeadId;
        if (
          ["autoplay_upload_success", "hubspot_upload_success"].includes(
            response.data.uploadStatus
          ) &&
          (appraisalId || hubspotLeadId)
        ) {
          this.isAppraisalReady = true;
          clearInterval(this.appraisalCheckInterval);
          clearTimeout(this.appraisalTimeout);
          this.redirectToMyCarPage(appraisalId, hubspotLeadId);
        }
      } catch (error) {
        console.error("Error checking appraisal status:", error);
      }
    },
  },
  beforeDestroy() {
    this.stopTextRotation();
    clearInterval(this.appraisalCheckInterval);
    clearTimeout(this.appraisalTimeout);
  },
};
</script>

<style lang="scss">
@import url(https://fonts.googleapis.com/css?family=Open+Sans:300);

.loading-screen-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #2bb673;
  overflow: hidden;
}

.moving-car {
  .longfazers {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;

    span {
      position: absolute;
      height: 2px;
      width: 20%;
      background: #000;
    }

    span:nth-child(1) {
      top: 20%;
      animation: lf 0.6s linear infinite;
      animation-delay: -5s;
    }

    span:nth-child(2) {
      top: 40%;
      animation: lf2 0.8s linear infinite;
      animation-delay: -1s;
    }

    span:nth-child(3) {
      top: 60%;
      animation: lf3 0.6s linear infinite;
    }

    span:nth-child(4) {
      top: 80%;
      animation: lf4 0.5s linear infinite;
      animation-delay: -3s;
    }
  }

  .centerpiece {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;

    .body {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      h1 {
        margin-top: 40px;
        font-family: 'Open Sans';
        font-weight: 600;
        font-size: 12px;
        text-transform: uppercase;
        color: #000;
        z-index: 100;
      }

      .fazers {
        position: absolute;
        top: 60%;
        left: -25px;
        transform: translateY(-50%);
        z-index: 1;

        span {
          width: 30px;
          height: 1px;
          background: #000;
          position: absolute;
          left: 0;
          animation: fazer1 0.2s linear infinite;
        }

        span:nth-child(2) {
          top: 3px;
          animation: fazer2 0.4s linear infinite;
        }

        span:nth-child(3) {
          top: 1px;
          animation: fazer3 0.4s linear infinite;
          animation-delay: -1s;
        }

        span:nth-child(4) {
          top: 4px;
          animation: fazer4 1s linear infinite;
          animation-delay: -1s;
        }
      }

      .car-wrapper {
        position: relative;
        z-index: 10;

        .car-icon {
          width: 80px;
          height: auto;
          animation: speeder 0.4s linear infinite;
        }
      }
    }

    .redirect-text {
      margin-top: 40px;
      font-family: "Avenir Next", "Avenir", "Helvetica Neue", sans-serif;
      font-weight: 500;
      font-size: 28px;
      color: #000;
      z-index: 100;
    }
  }
}

.come-back-later {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;

  .come-back-later-text {
    font-size: 32px;
    p {
      width: 100vw;
      margin-top: 30px;
      color: #000;
      z-index: 100;
    }
  }
}

@keyframes fazer1 {
  0% { left: 0; }
  100% { left: -80px; opacity: 0; }
}

@keyframes fazer2 {
  0% { left: 0; }
  100% { left: -100px; opacity: 0; }
}

@keyframes fazer3 {
  0% { left: 0; }
  100% { left: -50px; opacity: 0; }
}

@keyframes fazer4 {
  0% { left: 0; }
  100% { left: -150px; opacity: 0; }
}

@keyframes lf {
  0% { left: 200%; }
  100% { left: -200%; opacity: 0; }
}

@keyframes lf2 {
  0% { left: 200%; }
  100% { left: -200%; opacity: 0; }
}

@keyframes lf3 {
  0% { left: 200%; }
  100% { left: -100%; opacity: 0; }
}

@keyframes lf4 {
  0% { left: 200%; }
  100% { left: -100%; opacity: 0; }
}

@keyframes speeder {
  0%   { transform: translate(2px, 1px) rotate(0deg); }
  10%  { transform: translate(-1px, -3px) rotate(-1deg); }
  20%  { transform: translate(-2px, 0px) rotate(1deg); }
  30%  { transform: translate(1px, 2px) rotate(0deg); }
  40%  { transform: translate(1px, -1px) rotate(1deg); }
  50%  { transform: translate(-1px, 3px) rotate(-1deg); }
  60%  { transform: translate(-1px, 1px) rotate(0deg); }
  70%  { transform: translate(3px, 1px) rotate(-1deg); }
  80%  { transform: translate(-2px, -1px) rotate(1deg); }
  90%  { transform: translate(2px, 1px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

@media screen and(max-width: 768px) {
  .come-back-later-text {
    font-size: 24px !important;
  }
}
@media screen and(max-width: 540px) {
  .come-back-later-text {
    font-size: 17px !important;
  }
}
@media screen and(max-width: 380px) {
  .come-back-later-text {
    font-size: 14px !important;
  }
}
</style>